import React from 'react';
import { IconLoader } from 'common/IconLoader';
import Modal from 'components/shared/Modal/Modal';
import { isDeviceLocked } from 'common/utils/deviceTwinUtils';
import classnames from 'classnames';
import './LockUnlockModal.css';

const LockUnlockModal = (props) => {
  const isLocked = isDeviceLocked(props.device);

  return (
    <Modal
      role="alertdialog"
      aria-labelledby="lock_unlock_modal_title"
      close={props.close}
      animate={false}
      animateX={false}
      opaque={true}
      height={245}
      width={504}
      noPadding={true}
    >
      <div className="LockUnlockModal">
        <div id="lock_unlock_modal_title" className="LockUnlockModal_Header_Div">
          <img
            alt=""
            className="LockUnlockModal_LockUnlockIcon"
            src={isLocked ? IconLoader.icon_unlocked : IconLoader.icon_locked}
          ></img>
          <span style={{ fontWeight: 500, color: isLocked ? '#005082' : '#C60000', marginRight: '4px' }}>
            {isLocked ? 'Unlock' : 'Lock'}
          </span>{' '}
          this device?
        </div>

        <div className="LockUnlockModal_Description_Div">
          <span>{isLocked ? '' : '5G Service will be interrupted.'}</span>
        </div>

        <div className="LockUnlockModal_Buttons">
          <button className="Global_RoundedButton LockUnlockModal_CancelButton" onClick={props.close}>
            Cancel
          </button>
          <button
            className={classnames({
              Global_RoundedButton: true,
              LockUnlockModal_Lock_ConfirmButton: !isLocked,
              LockUnlockModal_Unlock_ConfirmButton: isLocked
            })}
            onClick={() => {
              props.close();
              props.action(props.device);
            }}
          >
            Yes, <span style={{ fontWeight: 400 }}>{isLocked ? 'unlock' : 'lock'}</span> this device
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default LockUnlockModal;
